import type { ChangelogEntry } from "../types";

/** Tilgangsmatrisen styrer fravær, økonomiskriving og produksjonsdisplayet. */
export const TILGANG_FRAVAER_OG_DISPLAY_2026_10: ChangelogEntry = {
  id: "2026-10-25-tilgang-fravaer-og-display",
  date: "2026-10-25",
  title: "Tilgangene under Innstillinger gjelder også i databasen",
  summary:
    "Fravær med type og notat vises bare for den ansatte selv og administratorer, endringer i bilag, salgsenheter og avtaler følger tilgangene, og produksjonsdisplayet åpnes for alle med Display.",
  sections: [
    {
      heading: "Tilganger",
      items: [
        {
          title: "Fraværstype og notat er private",
          kind: "forbedret",
          body: "Andre ansatte ser ikke lenger hva slags fravær du har eller notatet ditt. Kapasitet og faktureringsgrad regnes som før, med datoer og timer.",
        },
        {
          title: "Endringer i bilag, salgsenheter og avtaler følger tilgangene",
          kind: "forbedret",
          body: "Bare roller som har Fakturering, Organisasjon eller Avtaler under Tilganger og roller, eller bilagsgodkjenning på prosjektet, kan endre disse dataene.",
        },
        {
          title: "Produksjonsdisplayet åpnes for alle med Display",
          kind: "rettet",
          body: "Displayet slapp bare inn administratorer, også for TV-skjermkontoen. Nå avgjør Display under Tilganger og roller hvem som ser det.",
        },
      ],
    },
  ],
};
